import { ACTION_CHANGE_QUEST_ANSWER } from "../views/app"; // Action Creators - funcs, who return actions

const initialState = {
	currentQuestIDinStore: 0,
	name: "Unnamed"
};

export const userReducer = (state = initialState, action) => {
	switch (action.type) {
		case "CHANGE_CURRENT_QUEST_ID":
			return { ...state, currentQuestIDinStore: action.payload };
	}
	return state;
};
